import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Tag } from "@prism/prism-shared";

export const LoadTags = createActionGroup({
    source: 'Shared LoadTags',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tags: Tag[]}>(),
        'Failure': props<{ error: any }>(),
    }
})